/**
 * Dragon Ball Themed Color Schemes
 * Each theme is inspired by iconic characters/transformations
 */

export const DB_THEMES = {
  saiyan: {
    id: 'saiyan',
    name: 'Saiyan (Default)',
    description: "Goku's classic orange gi",
    icon: '🟠',
    colors: {
      primary: '#f97316',      // Orange
      secondary: '#eab308',    // Yellow
      accent: '#fbbf24',       // Gold
      background: '#0a0a0a',   // Dark
      card: '#141414',
      border: 'rgba(249, 115, 22, 0.2)',
      text: '#ffffff',
      muted: '#9ca3af',
    },
    backgroundImage: 'https://static.prod-images.emergentagent.com/jobs/5761213e-5438-4ff2-b06e-ef34e7a4c3e1/images/4730e1c7b75ed25bc7517eb432c7bb870d7d3122ad25efe888065983a2fca745.png'
  },
  vegeta: {
    id: 'vegeta',
    name: 'Vegeta Royal',
    description: "The Saiyan Prince's royal blue",
    icon: '🔵',
    colors: {
      primary: '#3b82f6',      // Royal Blue
      secondary: '#1d4ed8',    // Deep Blue
      accent: '#60a5fa',       // Light Blue
      background: '#0a0a12',   // Dark Blue-ish
      card: '#111827',
      border: 'rgba(59, 130, 246, 0.2)',
      text: '#ffffff',
      muted: '#9ca3af',
    },
    backgroundImage: 'https://static.prod-images.emergentagent.com/jobs/5761213e-5438-4ff2-b06e-ef34e7a4c3e1/images/1e11685180843be5c65edcd9c62c91caaf1b3606616a17231248047b610c127e.png'
  },
  frieza: {
    id: 'frieza',
    name: 'Frieza Force',
    description: "The tyrant's purple empire",
    icon: '🟣',
    colors: {
      primary: '#a855f7',      // Purple
      secondary: '#7c3aed',    // Violet
      accent: '#c084fc',       // Light Purple
      background: '#0a0a0f',   // Dark Purple-ish
      card: '#1a1625',
      border: 'rgba(168, 85, 247, 0.2)',
      text: '#ffffff',
      muted: '#a1a1aa',
    },
    backgroundImage: 'https://static.prod-images.emergentagent.com/jobs/5761213e-5438-4ff2-b06e-ef34e7a4c3e1/images/02c5c4424ba5597e594564091d6534db21fd7c7ffabea0ec75b0d215a8f22264.png'
  },
  namek: {
    id: 'namek',
    name: 'Namekian',
    description: "Piccolo's warrior spirit",
    icon: '🟢',
    colors: {
      primary: '#22c55e',      // Green
      secondary: '#16a34a',    // Deep Green
      accent: '#4ade80',       // Light Green
      background: '#0a0f0a',   // Dark Green-ish
      card: '#0f1a14',
      border: 'rgba(34, 197, 94, 0.2)',
      text: '#ffffff',
      muted: '#9ca3af',
    },
    backgroundImage: 'https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/d51af3bec4741c7d_1320540.png'
  },
  buu: {
    id: 'buu',
    name: 'Majin Buu',
    description: "Chaotic pink energy",
    icon: '🩷',
    colors: {
      primary: '#ec4899',      // Pink
      secondary: '#db2777',    // Deep Pink
      accent: '#f472b6',       // Light Pink
      background: '#0f0a0d',   // Dark Pink-ish
      card: '#1a1018',
      border: 'rgba(236, 72, 153, 0.2)',
      text: '#ffffff',
      muted: '#a1a1aa',
    },
    backgroundImage: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/lvgenwnk_ejcDiL.webp',
    backgroundPosition: 'right center',
    mobileBackgroundPosition: '75% center'
  },
  ultraInstinct: {
    id: 'ultraInstinct',
    name: 'Ultra Instinct',
    description: "Beyond Saiyan limits",
    icon: '⚪',
    colors: {
      primary: '#e2e8f0',      // Silver
      secondary: '#94a3b8',    // Gray Blue
      accent: '#38bdf8',       // Cyan accent
      background: '#0f172a',   // Dark Slate
      card: '#1e293b',
      border: 'rgba(226, 232, 240, 0.15)',
      text: '#f1f5f9',
      muted: '#94a3b8',
    },
    backgroundImage: 'https://static.prod-images.emergentagent.com/jobs/5761213e-5438-4ff2-b06e-ef34e7a4c3e1/images/f15487f31ef1a350e56dd0b6037a8ac55b5fb05a0f8fb7a7b96f66196136fb57.png'
  },
  ssjGod: {
    id: 'ssjGod',
    name: 'Super Saiyan God',
    description: "Divine crimson power",
    icon: '🔴',
    colors: {
      primary: '#ef4444',      // Red
      secondary: '#dc2626',    // Deep Red
      accent: '#f87171',       // Light Red
      background: '#0f0a0a',   // Dark Red-ish
      card: '#1a1212',
      border: 'rgba(239, 68, 68, 0.2)',
      text: '#ffffff',
      muted: '#a1a1aa',
    },
    backgroundImage: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/sdf30wle_F36EZu.webp',
    backgroundPosition: 'right center',
    mobileBackgroundPosition: '65% center'
  },
  blackRose: {
    id: 'blackRose',
    name: 'Goku Black Rosé',
    description: "Divine justice in darkness",
    icon: '🌹',
    colors: {
      primary: '#be185d',      // Rose
      secondary: '#9d174d',    // Deep Rose
      accent: '#f43f5e',       // Pink accent
      background: '#030303',   // Pure Dark
      card: '#0d0d0d',
      border: 'rgba(190, 24, 93, 0.25)',
      text: '#fdf2f8',
      muted: '#9ca3af',
    },
    backgroundImage: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/mt7a0rcp_download.webp',
    backgroundPosition: 'center center'
  },
  cell: {
    id: 'cell',
    name: 'Perfect Cell',
    description: "Bio-android perfection",
    icon: '🦗',
    colors: {
      primary: '#84cc16',      // Lime
      secondary: '#65a30d',    // Deep Lime
      accent: '#a3e635',       // Light Lime
      background: '#0a0d0a',   // Dark
      card: '#111a11',
      border: 'rgba(132, 204, 22, 0.2)',
      text: '#ffffff',
      muted: '#9ca3af',
    },
    backgroundImage: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/83dii3jr_wp2019813.webp',
    backgroundPosition: 'right center',
    mobileBackgroundPosition: '60% center'
  },
  shenron: {
    id: 'shenron',
    name: 'Shenron',
    description: "The eternal dragon's wish",
    icon: '🐉',
    colors: {
      primary: '#14b8a6',      // Teal
      secondary: '#0d9488',    // Deep Teal
      accent: '#fbbf24',       // Dragon Ball Gold
      background: '#021a1a',   // Dark Teal-ish
      card: '#0a2020',
      border: 'rgba(20, 184, 166, 0.2)',
      text: '#f0fdfa',
      muted: '#5eead4',
    },
    backgroundImage: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/8mw09o4a_images_2.webp',
    backgroundPosition: 'center center'
  },
  broly: {
    id: 'broly',
    name: 'Legendary Broly',
    description: "The Legendary Super Saiyan's rage",
    icon: '💚',
    colors: {
      primary: '#22c55e',      // Legendary Green
      secondary: '#15803d',    // Deep Forest Green
      accent: '#86efac',       // Light Green Glow
      background: '#030a05',   // Deep Dark Green
      card: '#0a1a0f',
      border: 'rgba(34, 197, 94, 0.3)',
      text: '#dcfce7',
      muted: '#86efac',
    },
    backgroundImage: 'https://static.prod-images.emergentagent.com/jobs/5761213e-5438-4ff2-b06e-ef34e7a4c3e1/images/8cb6409d18ce02a1840fe7c177fb823bfb4b9602828569a53b79758745efae5e.png'
  },
  beerus: {
    id: 'beerus',
    name: 'God of Destruction',
    description: "Beerus's divine purple aura",
    icon: '😼',
    colors: {
      primary: '#7c3aed',      // Violet
      secondary: '#5b21b6',    // Deep Violet
      accent: '#c4b5fd',       // Light Violet
      background: '#0d0520',   // Dark Purple
      card: '#1a0f2e',
      border: 'rgba(124, 58, 237, 0.25)',
      text: '#f5f3ff',
      muted: '#a78bfa',
    },
    backgroundImage: 'https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/0906f64826c7c16c_wp9027438.webp',
    backgroundPosition: 'center center'
  },
  bardock: {
    id: 'bardock',
    name: 'Bardock',
    description: "The legendary Saiyan warrior - Father of Goku",
    icon: '🔥',
    colors: {
      primary: '#dc2626',      // Red
      secondary: '#7f1d1d',    // Dark Red
      accent: '#fbbf24',       // Gold
      background: '#1a0a0a',   // Dark blood red
      card: '#2d1111',
      border: 'rgba(220, 38, 38, 0.3)',
      text: '#fef2f2',
      muted: '#fca5a5',
      logoAccent: '#b91c1c',   // Blood red for TV logo
    },
    backgroundImage: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/khstkdat_hq720.jpg',
    backgroundPosition: 'center center',
    mobileBackgroundPosition: '55% 40%'
  },
  // ===== Halloween Shop themes (bought with candy, usable all year) =====
  halloweenGhosts: {
    id: 'halloweenGhosts',
    name: 'Trick-or-Treat Ghosts',
    description: "Gotenks' ghosts haunt the full moon",
    icon: '👻',
    halloween: true,
    colors: {
      primary: '#38bdf8', secondary: '#f97316', accent: '#7dd3fc',
      background: '#0b0f17', card: '#111827', border: 'rgba(56, 189, 248, 0.25)',
      text: '#f0f9ff', muted: '#94a3b8', logoAccent: '#f97316',
    },
    backgroundImage: 'https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/2339eb39fe086aa8_1793473750601.webp',
    backgroundPosition: 'center center',
    mobileBackgroundPosition: '48% center'
  },
  greatApe: {
    id: 'greatApe',
    name: 'Great Ape Rampage',
    description: 'An Oozaru looms under the full moon',
    icon: '🦍',
    halloween: true,
    colors: {
      primary: '#dc2626', secondary: '#a16207', accent: '#facc15',
      background: '#140d07', card: '#21160c', border: 'rgba(220, 38, 38, 0.25)',
      text: '#fefce8', muted: '#d6c7a1', logoAccent: '#dc2626',
    },
    backgroundImage: 'https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/7778d55d4af86fac_wp7761338.jpg',
    backgroundPosition: 'center center',
    mobileBackgroundPosition: '68% center'
  },
  shadowSaga: {
    id: 'shadowSaga',
    name: 'Shadow Ape',
    description: 'Saiyan silhouettes with glowing red eyes',
    icon: '🌑',
    halloween: true,
    colors: {
      primary: '#e11d48', secondary: '#78350f', accent: '#f5d0a9',
      background: '#0d0907', card: '#1a130e', border: 'rgba(225, 29, 72, 0.25)',
      text: '#fdf6ec', muted: '#c4a988', logoAccent: '#e11d48',
    },
    backgroundImage: 'https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/a44ed40765c233c3_f4i24uako7d41.jpg',
    backgroundPosition: 'center center',
    mobileBackgroundPosition: '30% center'
  },
  vampireGoku: {
    id: 'vampireGoku',
    name: 'Vampire Goku',
    description: 'Count Kakarot rises on Halloween night',
    icon: '🧛',
    halloween: true,
    colors: {
      primary: '#b91c1c', secondary: '#4c0519', accent: '#f87171',
      background: '#0a0708', card: '#160d10', border: 'rgba(185, 28, 28, 0.3)',
      text: '#fff1f2', muted: '#a8a29e', logoAccent: '#b91c1c',
    },
    backgroundImage: 'https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/77b11a35f63e4b51_vampire_thinmasuke_me_ultimate_jumpscare_dragon_ball_super_x_halloween_horror__by_tmzstudioz_dn1u2r0-pre.jpg',
    backgroundPosition: 'center top',
    mobileBackgroundPosition: '50% top'
  }
};

export const DEFAULT_THEME = 'saiyan';

/**
 * Apply theme to document CSS variables
 */
export const applyTheme = (themeId) => {
  const theme = DB_THEMES[themeId] || DB_THEMES[DEFAULT_THEME];
  const root = document.documentElement;
  
  // Set CSS variables
  root.style.setProperty('--color-primary', theme.colors.primary);
  root.style.setProperty('--color-secondary', theme.colors.secondary);
  root.style.setProperty('--color-accent', theme.colors.accent);
  root.style.setProperty('--color-background', theme.colors.background);
  root.style.setProperty('--color-card', theme.colors.card);
  root.style.setProperty('--color-border', theme.colors.border);
  root.style.setProperty('--color-text', theme.colors.text);
  root.style.setProperty('--color-muted', theme.colors.muted);
  root.style.setProperty('--color-logo-accent', theme.colors.logoAccent || theme.colors.accent);
  
  // Handle background image if theme has one
  if (theme.backgroundImage) {
    root.style.setProperty('--theme-bg-image', `url(${theme.backgroundImage})`);
    root.style.setProperty('--theme-bg-position', theme.backgroundPosition || 'center center');
    root.style.setProperty('--theme-bg-position-mobile', theme.mobileBackgroundPosition || theme.backgroundPosition || 'center center');
  } else {
    root.style.setProperty('--theme-bg-image', 'none');
    root.style.setProperty('--theme-bg-position', 'center center');
    root.style.setProperty('--theme-bg-position-mobile', 'center center');
  }
  
  // Store in localStorage as backup
  localStorage.setItem('dragon-tv-theme', themeId);
  
  return theme;
};

/**
 * Get saved theme from localStorage
 */
export const getSavedTheme = () => {
  return localStorage.getItem('dragon-tv-theme') || DEFAULT_THEME;
};

export default DB_THEMES;
